import _ from 'underscore';

/////////////////////////////////////////////////////////////////////////
// DISPLAY HELPERS /////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const DisplayHelpers = {

  init: function(game) {

    this.game = game;

  },

  makeHitButton: function(x, y, width, height, callback, context, group) {

    var btn = new Phaser.Graphics(this.game, 0, 0);
    if (_.isFunction(group.add)) {
      group.add(btn);
    }
    else {
      group.addChild(btn);
    }
    btn.beginFill(0x0000ff);
    btn.drawRect(x, y, width, height);
    btn.endFill();
    btn.alpha = 0;
    btn.inputEnabled = true;

    if (_.isFunction(callback)) {
      btn.events.onInputUp.add(callback, context);
      btn.input.useHandCursor = true;

    }


    return btn;
  },

  shaveTileFrame: function(key, frame, shaveX, shaveY) {

    // to fix bad tiling by TileSprite, shave a pixel off the left and right edges
    var frameData = this.game.cache.getFrameData(key);
    var frame = frameData.getFrameByName(frame);

    if (shaveX)
    {
      frame.x += 1;
      frame.width -= 2;      
    }
    if (shaveY)
    {
      frame.y += 1;
      frame.height -= 2;            
    }
  },

  scaleXToFit: function(element, startScale, minScale, padding) {

    var minScale = minScale || 0.1;
    var scale = startScale || 1;
    var padding = padding || 0;
    
    do
    {
      element.scale.set(scale);
      scale -= 0.02;
    }
    while (element.width > this.game.width-padding && scale >= minScale);
  
  }

};

export default DisplayHelpers;






// WEBPACK FOOTER //
// ./app/src/utils/misc/DisplayHelpers.js